// These are some common fields that are present in multiple tables in DB
// They can be added to UI models...

import { IFieldText, IFieldMail, IFieldPickerItems, IFieldDateTime, IFieldWKT } from "@/@types/models/model";

const oib: IFieldText = {
  title: "OIB",
  source: "oib",
  ttoken: "common.oib",
  type: "text",
  validation: {
    required: true, //uncomment later but for now since no users have oib it can be non mandatory
    minLength: 11,
    maxLength: 11,
    function: "oib"
  },
  export: {
    width: 20
  }
};

const vat: IFieldText = {
  title: "VAT",
  source: "vat",
  ttoken: "common.vat",
  type: "text",
  validation: {
    required: true,
    maxLength: 50
  },
  export: {
    width: 20
  }
};

const email: IFieldMail = {
  title: "E-mail",
  source: "email",
  ttoken: "common.email",
  type: "mail",
  validation: {
    required: true,
    maxLength: 250,
    function: "email"
  },
  export: {
    width: 30
  }
};

const tel: IFieldText = {
  title: "Telephone",
  source: "tel",
  ttoken: "common.tel",
  type: "text",
  //placeholder: "+385xxxxxxxxx",
  validation: {
    required: false,
    //function: "tel"
    maxLength: 20
  },
  export: {
    width: 25
  }
};

const mobile: IFieldText = {
  title: "Mobile phone",
  source: "mobile",
  ttoken: "common.mobile",
  type: "text",
  validation: {
    required: false,
    maxLength: 20
  },
  export: {
    width: 25
  }
};

const wkt: IFieldWKT = {
  title: "WKT",
  source: "wkt",
  ttoken: "common.wkt",
  type: "wkt",
  validation: {
    required: true,
    maxLength: 99999
  },
  readonly: true,
  width: "full"
}

const proj: IFieldText = {
  title: "WKT Projection",
  source: "proj",
  ttoken: "common.projection",
  type: "text",
  readonly: true
}

const hgss_zemljovid: IFieldText = {
  title: "HGSS Zemljovid",
  source: "hgss_zemljovid",
  ttoken: "common.hgss_zemljovid",
  type: "text",
  readonly: true
}

const podrucje: IFieldText = {
  title: "Podrucje",
  source: "podrucje",
  ttoken: "common.podrucje",
  type: "text",
  readonly: true
}

const planina: IFieldText = {
  title: "Planina",
  source: "planina",
  ttoken: "common.planina",
  type: "text",
  readonly: true
}

const owner_organisation: IFieldPickerItems = 
{
  title: "owner_organisation",
  source: "owner_organisation",
  ttoken: "common.owner_organisation",
  type: "picker",
  items: {
    values: [20, 30],
    labels: ["common.hgss", "common.hps"]
  },
  validation: {
    required: true
  },
  translate: true,
  readonly: true
}

const data_source: IFieldPickerItems =
{
  title: "data_source",
  source: "data_source",
  ttoken: "common.data_source",
  type: "picker",
  items: {
    values: [20, 30, 50, 61, 62, 63, 70],
    labels: ["common.hgss", "common.hps", "common.hps-hgss", "common.via-dinarica", "common.via-adriatica", "common.cldt", 'common.tz']
  },
  validation: {
    required: true
  },
  translate: true,
  readonly: true
}

const hgss_modified_on: IFieldDateTime = {
  title: "HGSS Modified On",
  source: "hgss_modified_on",
  ttoken: "common.modified_on",
  type: "datetime",
  readonly: true,
  export: {
    width: 20
  }
};

const hgss_modified_by: IFieldText = {
  title: "HGSS Modified By",
  source: "hgss_modified_by",
  ttoken: "common.modified_by",
  type: "text",
  readonly: true
};

const hps_modified_on: IFieldDateTime = {
  title: "HPS Modified On",
  source: "hps_modified_on",
  ttoken: "common.modified_on",
  type: "datetime",
  readonly: true,
  export: {
    width: 20
  }
};

const hps_modified_by: IFieldText = {
  title: "HPS Modified By",
  source: "hps_modified_by",
  ttoken: "common.modified_by",
  type: "text",
  readonly: true
};

export const commonFields = {
  oib,
  vat,
  email,
  tel,
  mobile,
  wkt,
  proj,
  hgss_zemljovid,
  podrucje,
  planina,
  owner_organisation,
  data_source,
  hgss_modified_on,
  hgss_modified_by,
  hps_modified_on,
  hps_modified_by
};
